<div class="pager">
  <div class="size-box">
    <span>ردیف در صفحه</span>
    <select class="size-select" [ngModel]="pageSize" (ngModelChange)="onPageSizeSelected($event)">
      <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size | faNum }}</option>
    </select>
  </div>

  <nav class="pages" aria-label="صفحه‌بندی">
    <button class="pg-btn" type="button" aria-label="صفحه قبل" [disabled]="currentPage <= 1"
      (click)="requestPage(currentPage - 1)">
      <i class="fa fa-chevron-right"></i>
    </button>

    <div class="page-nums">
      <ng-container *ngFor="let item of pageNumbers">
        <span *ngIf="item === -1" class="pg-btn dots">…</span>
        <button *ngIf="item !== -1" class="pg-btn" type="button" [class.current]="item === currentPage"
          (click)="requestPage(item)">{{ item | faNum }}</button>
      </ng-container>
    </div>

    <button class="pg-btn" type="button" aria-label="صفحه بعد" [disabled]="currentPage >= totalPages"
      (click)="requestPage(currentPage + 1)">
      <i class="fa fa-chevron-left"></i>
    </button>
  </nav>
</div>
